import ApiService from '@/api';
import { ResponseModel } from '@/models';
import { NamespaceModel } from '../models';
import { mapGetNamespacesRequest, mapGetNamespacesResponse } from './AdapterServiceMappers';
import { Events } from 'tir-pm-toolkit';
import { CreateNamespaceInfo, DeleteNamespaceInfo, UpdateNamespaceInfo } from '../types';
import ProjectNamespaceListRequest from '@/components/tasks-kanban/adapter/TaskKanbanAdapterService';

export class AdapterService {
  private readonly api = new ApiService();

  /**Событие создания неймспейса */
  CreateNamespaceEvent = new Events<NamespaceModel>();
  /**Событие удаления неймспейса */
  DeleteNamespaceEvent = new Events<DeleteNamespaceInfo>();
  /**Событие обновления неймспейса */
  UpdateNamespaceEvent = new Events<Partial<NamespaceModel>>();

  constructor() {
    this.api.Main.ProjectNamespaceService.OnCreateNamespaceEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.CreateNamespaceEvent.trigger(
          new NamespaceModel({
            Id: resp.Value.Id,
            ProjectId: resp.Value.ProjectId,
            Name: resp.Value.Name,
            IconId: resp.Value.SettingIconId,
            IconUrl: resp.Value.IconUrl,
            ColorId: resp.Value.SettingColorId,
            Color: resp.Value.Color,
            TasksCount: 0,
            // !Нет поля IsAdmin
            IsAdmin: false,
          }),
        );
      }
    });

    this.api.Main.ProjectNamespaceService.DeleteEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.DeleteNamespaceEvent.trigger({
          NamespaceId: String(resp.Value),
        });
      }
    });
    this.api.Main.ProjectNamespaceService.OnDeleteNamespaceEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.DeleteNamespaceEvent.trigger({
          NamespaceId: resp.Value.NamespaceId,
        });
      }
    });

    this.api.Main.ProjectNamespaceService.UpdateEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.UpdateNamespaceEvent.trigger({
          Id: resp.Value.Id,
          Name: resp.Value.Name,
          IconId: resp.Value.IconId,
          IconUrl: resp.Value.IconUrl,
          ColorId: resp.Value.ColorId,
          Color: resp.Value.Color,
        });
      }
    });
    this.api.Main.ProjectNamespaceService.OnUpdateNamespaceEventEvent.on((resp) => {
      if (resp.IsSuccess && resp.Value) {
        this.UpdateNamespaceEvent.trigger({
          Id: resp.Value.Id,
          Name: resp.Value.Name,
          IconId: resp.Value.IconId,
          IconUrl: resp.Value.IconUrl,
          ColorId: resp.Value.ColorId,
          Color: resp.Value.Color,
        });
      }
    });
  }

  /**
   * * Получить список неймспейсов
   * @param projectId ID проекта
   * @returns
   */
  getNamespaces(req: ProjectNamespaceListRequest) {
    return new Promise<ResponseModel<Array<NamespaceModel>>>(async (resolve) => {
      const result = new ResponseModel<Array<NamespaceModel>>();

      await this.api.Main.ProjectNamespaceService.getListAsync(req)
        .then((resp) => {
          result.Value = mapGetNamespacesResponse(resp);
          return resolve(result);
        })
        .catch((e) => {
          result.IsSuccess = false;
          result.ErrorCode = e?.ErrorCode;
          result.ErrorMessage = e?.ErrorMessage;
          console.error('ERROR getNamespaces', e);
          return resolve(result);
        });
    });
  }
}
